var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTagLink = function SvgTagLink(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99 16.135c0 .28.117.558.326.768l1.443 1.303a5.902 5.902 0 0 0 4.236 1.792 5.974 5.974 0 0 0 4.236-1.769A5.971 5.971 0 0 0 20 13.994 5.971 5.971 0 0 0 18.23 9.76l-1.373-1.373a1.095 1.095 0 0 0-.768-.326c-.28 0-.559.117-.768.326-.21.21-.326.489-.326.768 0 .28.116.558.326.768l1.373 1.373a3.797 3.797 0 0 1 1.117 2.722 3.798 3.798 0 0 1-1.117 2.723 3.8 3.8 0 0 1-2.723 1.117 3.839 3.839 0 0 1-2.723-1.117l-1.374-1.373a1.096 1.096 0 0 0-.768-.326c-.279 0-.558.117-.768.326a.994.994 0 0 0-.349.768Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.566 7.66c0 .28.117.559.326.768l4.632 4.608c.442.442 1.117.442 1.536 0 .419-.42.419-1.094 0-1.513L8.428 6.916a1.095 1.095 0 0 0-.768-.326c-.279 0-.558.116-.768.326-.186.209-.302.465-.326.744Z",
    fill: "currentColor"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.078 4.654c.21.21.489.326.768.326.28 0 .559-.117.768-.326a1.068 1.068 0 0 0 0-1.513L10.241 1.77A5.879 5.879 0 0 0 6.005 0a5.951 5.951 0 0 0-4.236 1.745A5.972 5.972 0 0 0 0 5.98c0 1.583.628 3.095 1.769 4.236l1.373 1.373c.442.442 1.117.442 1.536 0 .21-.21.326-.49.326-.769s-.116-.558-.326-.767L3.305 8.68a3.797 3.797 0 0 1-1.117-2.723c0-1.047.395-2.001 1.117-2.722a3.799 3.799 0 0 1 2.723-1.117c1.024 0 2.002.395 2.723 1.117l1.327 1.419Z",
    fill: "currentColor"
  })));
};
export default SvgTagLink;